module.exports = __webpack_public_path__ + "static/img/20221201_03.bc45373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/20221201_03.png
// module id = rHWh
// module chunks = 0